import ApiService from './ApiService';

let commList = [];


const callService = () => {
    let filteredData = [];
    ApiService.getAllQuotesCommodity()
        .then(result => {
            console.log('Commodities', result);
            for (var i = 0; i < result.length; i++) {
                filteredData.push(result[i]);
            }
            setCommList(filteredData);

            ApiService.getIndex()
                .then(result => {
                    for (i = 0; i < result.length; i++) {
                        filteredData.push(result[i]);
                    }
                    console.log('Commodities1', result, filteredData);
                    setCommList(filteredData);

                    ApiService.getAllQuotesForex()
                    .then(result => {
                        for (i = 0; i < result.length; i++) {
                            filteredData.push(result[i]);
                        }
                        console.log('Commodities2', result, filteredData);
                        setCommList(filteredData);

                        ApiService.getAllQuotesCrypto()
                        .then(result => {
                            for (i = 0; i < result.length; i++) {
                                filteredData.push(result[i]);
                            }
                            console.log('Commodities3', result, filteredData);
                            setCommList(filteredData);
                        })
                        .catch((error) => {
                            console.log(error);
                        });

                    })
                    .catch((error) => {
                        console.log(error);
                    });
                })
                .catch((error) => {
                    console.log(error);
                });

        })
        .catch((error) => {
            console.log(error);
        });

}

const getCommList = () => {
    return commList;
}

const setCommList = (list) => {
    commList = list;
}

const getPrePostCommData = (symbol) => {
    let list = getCommList();
    for(var i=0; i<list.length; i++){
        if (symbol === list[i].symbol){
            return list[i];
        }
    }
    return undefined;
}

export {getPrePostCommData, callService};